import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import FilterHeader from './FilterHeader';
import AnvendelseSpecifik from './AnvendelseSpecifik';
import FilterListItem from './FilterListItem';
import SwatchBookIcon from '../../common/Icons/Light/SwatchBook';
import { getAnvgenForKode } from '../../Map/util/koder';
import { neutral } from '../../../style/colors';
import {
  setAnvendelseFilterToggled,
  toggleAnvgen,
  setActiveStyle as setActiveStyleAction,
  setToggledAnvspecs,
} from '../../../store/actions';
import {
  IAppState,
  activeStyle as activeStyleEnum,
} from '../../../store/interfaces/state';

const Anvendelse = (props: IAnvendelsePropTypes) => {
  const {
    toggledAnvgens,
    toggleAnvgen,
    toggledAnvspecs,
    setToggledAnvspecs,
    toggled,
    setToggled,
    activeStyle,
    setActiveStyle,
  } = props;

  const [display, setDisplay] = useState('block');
  const swatchBookIcon = (
    <SwatchBookIcon
      width={20}
      color={
        activeStyle === activeStyleEnum.generelAnvendelse
          ? neutral[600]
          : neutral[300]
      }
    />
  );
  const filterAnimation = useSpring({
    display,
    borderBottom: `1px solid ${neutral[200]}`,
    opacity: toggled ? 1 : 0,
    height: toggled
      ? `${322 +
      54 *
      (toggledAnvspecs.length & 1
        ? (toggledAnvspecs.length + 1) / 2
        : toggledAnvspecs.length / 2)}px`
      : '0px',
    onRest: () => {
      if (!toggled) {
        setDisplay('none');
      }
    },
    onStart: () => {
      if (toggled) {
        setDisplay('block');
      }
    },
  });
  return (
    <div>
      <FilterHeader
        title={'Anvendelse'}
        iconToggled={activeStyle === activeStyleEnum.generelAnvendelse}
        icon={swatchBookIcon}
        toggled={toggled}
        onClick={() => setToggled(!toggled)}
        onIconClick={() => setActiveStyle(activeStyleEnum.generelAnvendelse)}
      />
      <animated.div style={filterAnimation}>
        <Filters>
          <FilterColumn>
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(11)}
              toggled={toggledAnvgens.indexOf(11) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#E1B7A0'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(21)}
              toggled={toggledAnvgens.indexOf(21) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#CA9FA0'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(31)}
              toggled={toggledAnvgens.indexOf(31) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#B5DAE4'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(41)}
              toggled={toggledAnvgens.indexOf(41) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#E3B2CD'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(51)}
              toggled={toggledAnvgens.indexOf(51) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#DAEAC7'
                  : neutral[500]
              }
            />
          </FilterColumn>
          <FilterColumn>
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(61)}
              toggled={toggledAnvgens.indexOf(61) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#F2DCB5'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(71)}
              toggled={toggledAnvgens.indexOf(71) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#EFECAB'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(81)}
              toggled={toggledAnvgens.indexOf(81) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#BCC2DB'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(91)}
              toggled={toggledAnvgens.indexOf(91) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#B9E1CE'
                  : neutral[500]
              }
            />
            <FilterListItem
              onClick={toggleAnvgen}
              kode={getAnvgenForKode(96)}
              toggled={toggledAnvgens.indexOf(96) > -1}
              backgroundColor={
                activeStyle === activeStyleEnum.generelAnvendelse
                  ? '#D1D1D5'
                  : neutral[500]
              }
            />
          </FilterColumn>
        </Filters>
        <AnvendelseSpecifik
          toggledAnvspecs={toggledAnvspecs}
          setToggledAnvspecs={setToggledAnvspecs}
        />
      </animated.div>
    </div>
  );
};
const Filters = styled.div`
  display: flex;
  overflow: hidden;
`;
const FilterColumn = styled.div`
  width: 50%;
  border-top: 1px solid ${neutral[150]};
  &:first-child {
    border-right: 1px solid ${neutral[150]};
  }
`;

const mapStateToProps = (state: IAppState) => {
  return {
    toggled: state.filterToggled.anvendelse,
    toggledAnvgens: state.filters.generelAnvendelse,
    activeStyle: state.style.activeStyle,
    toggledAnvspecs: state.filters.specifikAnvendelse,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToggled: toggled => {
      dispatch(setAnvendelseFilterToggled(toggled));
    },
    toggleAnvgen: kode => {
      dispatch(toggleAnvgen(kode));
    },
    setActiveStyle: activeStyle => {
      dispatch(setActiveStyleAction(activeStyle));
    },
    setToggledAnvspecs: anvspecs => {
      dispatch(setToggledAnvspecs(anvspecs));
    },
  };
};

interface IAnvendelsePropTypes {
  toggledAnvgens: Array<number>;
  toggleAnvgen: Function;
  toggledAnvspecs: Array<number>;
  setToggledAnvspecs: Function;
  toggled: boolean;
  setToggled: Function;
  activeStyle: string;
  setActiveStyle: Function;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Anvendelse);
